




















import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import auth from '@/firebaseApp'
import firebaseApp from '@/firebaseApp'
import Restaurants from '@/services/Restaurants'
import { User } from 'firebase'

@Component
export default class OwnerStaffList extends Vue {
  public restaurantId: string = ''
  public staffList: any = null

  async created() {
    this.restaurantId = this.$router.currentRoute.params.restaurantId

    const getStaff = firebaseApp.functions('europe-west1').httpsCallable('getStaff')
    this.staffList = (await getStaff({ restaurantId: this.restaurantId })).data
  }

  public async forgotPassword(email: string) {
    const continueUrl = `${window.config.baseUrl}/${this.restaurantId}/staff`
    await auth.auth().sendPasswordResetEmail(email, {
      url: continueUrl,
    })

    alert(`${email} ${this.$i18n.t('owner.staffList.receivedMail')}`)
  }

  public async deleteStaff(uid: string) {
    if (!confirm(this.$i18n.t('owner.staffList.confirm') + '')) {
      return
    }

    await Restaurants.deleteStaff(this.restaurantId, uid)

    const user = this.staffList.find((u: User) => u.uid === uid)
    const index = this.staffList.indexOf(user)
    this.staffList.splice(index, 1)
  }
}
